import { Injectable } from '@angular/core';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { Action } from '@ngrx/store/src/models';
import { GlobalSearchService } from '../../services/global-search/global-search.service';
import {
  GlobalSearchActionTypes,
  GlobalSearchSuccessAction,
  GlobalSearchErrorAction
} from '../../actions/global-search/global-search.actions';
import { GlobalSearchResults } from 'src/app/shared/models/global-search/GlobalSearchResults';

@Injectable()
export class GlobalSearchEffects {
  @Effect()
  public search(): Observable<Action> {
    return this.actions.pipe(
      ofType(GlobalSearchActionTypes.SEARCH),
      switchMap((action: any) => {
        return this.globalSearchService
          .getSearchResults(action.searchQuery, action.pagingConfig)
          .pipe(
            map((searchResults: GlobalSearchResults) =>
              GlobalSearchSuccessAction({ searchResults })
            ),
            catchError(error => of(GlobalSearchErrorAction({ error })))
          );
      })
    );
  }

  constructor(
    private actions: Actions,
    private globalSearchService: GlobalSearchService
  ) {}
}
